import { defineStore } from "pinia";
import { InitializationStatus } from "../constantes/constants";

/**
 * Handling of global app states at startup
 */
export const useStartupStore = defineStore('startup', {
    state: () => ({
        currentInitStatus: InitializationStatus.IDLE as InitializationStatus
    }),
    getters: {
        isMainInitializing(state) {
            return state.currentInitStatus == InitializationStatus.MAIN_INITIALIZATION;
        }
    }
})